// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { DawbaRoutes } from '../app/route-constants';
import { DAWBA_SENTRY_DSN, DawbaEnv, IDawbaCoreConfig } from './dawba-env';

export const environment: IDawbaCoreConfig = new DawbaEnv({
  production: true,
  debugMode: false,
  envName: 'prod',
  apiUrl: 'https://skema.dawba.dk/api/',
  appBuiltFor: 'DEV',
  sentry: { enabled: false, dsn: DAWBA_SENTRY_DSN },
  nemidUrl: 'https://dawba.dk/nemid-login/', // 'http://localhost:9999/',
  defaultAuthMethod: 'USERNAME_AND_PASSWORD',
  testPatientUserName: '',
  testPatientPassword: '',
  enableOnboarding: true,
  syncStateToStorage: true,
  enableDevAdmin: false,
  prefetchValueSets: false,
  backendAdminUser: 'infouser',
  backendAdminPassword: 'Infouser12@',
  mitIdLoginUrl: 'https://skema.dawba.dk/api/mitid-auth/login/',
  mitIdLogoutUrl: 'https://skema.dawba.dk/api/mitid-auth/logout/',
  mitIdCallbackRoute: DawbaRoutes.MitIdCallback,
});
